import QualityScoreDetails from '@components/V4/QualityScore/QualityScoreDetails';
import { SessionQualityScore } from '@shared/common';
import SessionModalEmptyState from '../../../DetailsModalEmptyState';

interface SessionScoringTabProps {
  qualityScoring?: SessionQualityScore;
}

const SessionScoringTab = (props: SessionScoringTabProps) => {
  const { qualityScoring } = props;

  if (!qualityScoring) return <SessionModalEmptyState />;

  return (
    <div className="rounded-2xl bg-surfaceBackground p-5">
      <QualityScoreDetails qualityScoring={qualityScoring} showOverallScore />
    </div>
  );
};

export default SessionScoringTab;
